export default __webpack_public_path__ + "static/media/vrChatİllu.bc42b570.svg";